// src/pages/help/topics/journalAuto.js
// Guide « Journal automatique ». Contenu validé — toute modification se fait ici.
export const fr = {
  title: "Journal automatique",
  tagline: "Suivi automatique de tes trades MT5",
  readMin: 6,
  intro:
    "Le Journal automatique est l'outil de FullMetrix qui récupère, organise et analyse les données provenant des comptes MetaTrader 5 connectés. Il permet de suivre son activité de trading sans enregistrer manuellement chaque position.",
  brief: [
    "Retrouver ses positions, résultats et statistiques sans saisie manuelle",
    "Filtrer par compte, période, actif, sens ou résultat",
    "Obtenir une Analyse IA de ses forces, erreurs et habitudes",
  ],
  steps: [
    {
      title: "Installer et connecter l'Agent IA",
      text: "Agent IA installé sur MetaTrader 5, compte connecté avec un token valide.",
    },
    {
      title: "Autoriser la communication",
      text: "Trading algorithmique activé et WebRequest de FullMetrix autorisé dans MT5.",
    },
    {
      title: "Laisser MetaTrader 5 ouvert",
      text: "MT5 ouvert et connecté à Internet : les données sont alors transférées automatiquement vers FullMetrix.",
    },
    {
      title: "Filtrer puis analyser",
      text: "Sélectionne le compte et la période, applique les filtres, puis consulte l'Analyse IA.",
    },
  ],
  tips: [
    "Un token différent par compte : c'est ce qui sépare proprement les statistiques.",
    "Le Journal ne prend ni ne modifie aucune position : ces actions sont dans la section Exécution.",
    "En cas de doute sur un chiffre, compare avec l'historique affiché directement dans MT5.",
  ],
  faq: [
    {
      q: "Qu'est-ce que le Journal automatique ?",
      a:
        "Le Journal automatique est l'outil de FullMetrix qui récupère, organise et analyse les données provenant des comptes MetaTrader 5 connectés.\n\n" +
        "Il permet de suivre son activité de trading sans enregistrer manuellement chaque position.",
    },
    {
      q: "Que faut-il faire pour l'utiliser ?",
      a:
        "Pour que les données apparaissent dans le journal, il faut :\n" +
        "• installer l'Agent IA sur MetaTrader 5\n" +
        "• connecter le compte avec un token valide\n" +
        "• activer le trading algorithmique\n" +
        "• autoriser le WebRequest de FullMetrix\n" +
        "• laisser MetaTrader 5 ouvert et connecté à Internet\n\n" +
        "Une fois la connexion établie, les données sont automatiquement transférées vers FullMetrix.",
    },
    {
      q: "Quelles informations peut-on retrouver dans le journal ?",
      a:
        "Le journal permet notamment de consulter :\n" +
        "• les positions ouvertes et clôturées\n" +
        "• les gains et les pertes\n" +
        "• le nombre total de trades\n" +
        "• le taux de réussite\n" +
        "• les résultats par actif\n" +
        "• les performances en BUY et en SELL\n" +
        "• les volumes utilisés\n" +
        "• les Stop Loss et Take Profit\n" +
        "• le drawdown\n" +
        "• l'évolution générale du compte",
    },
    {
      q: "Les trades sont-ils ajoutés automatiquement ?",
      a:
        "Oui.\n\n" +
        "Lorsque l'Agent IA est correctement connecté, les trades du compte MT5 sont automatiquement ajoutés au journal.\n\n" +
        "L'utilisateur n'a normalement pas besoin de les enregistrer manuellement.",
    },
    {
      q: "Peut-on consulter plusieurs comptes ?",
      a:
        "Oui.\n\n" +
        "L'utilisateur peut connecter plusieurs comptes MT5 à FullMetrix.\n\n" +
        "Pour séparer clairement les statistiques de chaque compte, il est recommandé d'utiliser un token différent pour chaque compte.\n\n" +
        "Si plusieurs comptes utilisent le même token, leurs données peuvent être regroupées dans le même journal.\n\n" +
        "Cela peut être utile pour obtenir une vue globale, mais peut aussi rendre l'analyse d'un compte précis plus difficile.",
    },
    {
      q: "Peut-on filtrer les données ?",
      a:
        "Oui.\n\n" +
        "Selon les options disponibles, l'utilisateur peut filtrer les résultats par :\n" +
        "• compte\n" +
        "• période\n" +
        "• actif\n" +
        "• achat ou vente\n" +
        "• trade gagnant ou perdant\n" +
        "• position ouverte ou clôturée\n\n" +
        "Les filtres permettent d'analyser plus précisément une partie de son activité.",
    },
    {
      q: "À quoi sert l'Analyse IA du journal ?",
      a:
        "Le journal possède une partie Analyse IA capable d'étudier l'ensemble des données du compte connecté.\n\n" +
        "Elle peut aider l'utilisateur à identifier :\n" +
        "• ses forces\n" +
        "• ses erreurs les plus fréquentes\n" +
        "• les habitudes qui réduisent ses performances\n" +
        "• les actifs sur lesquels il est le plus ou le moins performant\n" +
        "• ses différences de résultats entre BUY et SELL\n" +
        "• les périodes où il obtient ses meilleurs ou ses moins bons résultats\n" +
        "• les problèmes liés à sa gestion du risque",
    },
    {
      q: "Que peut recommander l'Analyse IA ?",
      a:
        "À partir des données disponibles, l'Analyse IA peut proposer des pistes pour savoir quoi :\n" +
        "• améliorer\n" +
        "• modifier\n" +
        "• réduire\n" +
        "• arrêter\n" +
        "• continuer à appliquer\n\n" +
        "Les recommandations peuvent notamment concerner :\n" +
        "• la gestion du risque\n" +
        "• la taille des positions\n" +
        "• la fréquence de trading\n" +
        "• les actifs tradés\n" +
        "• les horaires ou journées de trading\n" +
        "• les habitudes gagnantes à conserver\n" +
        "• les comportements négatifs à corriger",
    },
    {
      q: "L'Analyse IA remplace-t-elle l'analyse personnelle du trader ?",
      a:
        "Non.\n\n" +
        "Les recommandations sont générées à partir des données disponibles dans le journal.\n\n" +
        "L'utilisateur doit toujours :\n" +
        "• vérifier les informations\n" +
        "• tenir compte du contexte de ses trades\n" +
        "• comparer les recommandations avec sa stratégie\n" +
        "• décider lui-même des changements à appliquer\n\n" +
        "L'Analyse IA aide à mieux comprendre les performances, mais ne garantit pas une amélioration automatique des résultats.",
    },
    {
      q: "Le Journal automatique peut-il modifier les positions ?",
      a:
        "Non.\n\n" +
        "Le Journal automatique sert principalement à récupérer, organiser et analyser les données du compte.\n\n" +
        "Il ne prend pas automatiquement de position et ne modifie pas les trades.\n\n" +
        "Les actions d'ouverture, de modification ou de fermeture se trouvent dans les outils prévus à cet effet, notamment la section Exécution.",
    },
    {
      q: "Pourquoi certains trades n'apparaissent-ils pas ?",
      a:
        "Les causes les plus fréquentes sont :\n" +
        "• MetaTrader 5 est fermé\n" +
        "• l'Agent IA n'est plus actif\n" +
        "• le trading algorithmique est désactivé\n" +
        "• le lien WebRequest a été supprimé\n" +
        "• le token est absent ou incorrect\n" +
        "• le compte MT5 est déconnecté\n" +
        "• la synchronisation n'est pas terminée\n" +
        "• le mauvais compte ou la mauvaise période est sélectionné",
    },
    {
      q: "Que faire si le journal ne se synchronise plus ?",
      a:
        "Vérifie :\n" +
        "• que MetaTrader 5 est ouvert\n" +
        "• que le compte de trading est connecté\n" +
        "• que l'Agent IA est toujours actif\n" +
        "• que le trading algorithmique est activé\n" +
        "• que https://ia.fullmargin.net est toujours autorisé dans les WebRequest\n" +
        "• que le token est correctement renseigné\n" +
        "• que le bon compte est sélectionné dans FullMetrix\n\n" +
        "Actualise ensuite la page du journal.",
    },
    {
      q: "Les résultats peuvent-ils être différents de ceux de MT5 ?",
      a:
        "Les données du journal proviennent du compte MetaTrader 5 connecté.\n\n" +
        "Une différence temporaire peut toutefois apparaître en cas de :\n" +
        "• retard de synchronisation\n" +
        "• mauvais compte sélectionné\n" +
        "• regroupement de plusieurs comptes avec le même token\n" +
        "• filtre actif\n" +
        "• période incorrecte\n" +
        "• problème de connexion de l'Agent\n\n" +
        "En cas de doute, compare les informations avec l'historique affiché directement dans MT5.",
    },
    {
      q: "Comment contacter le support ?",
      a:
        "Pour obtenir une réponse plus rapide, nous recommandons de contacter le support FullMargin par WhatsApp.\n\n" +
        "Il est conseillé d'envoyer :\n" +
        "• l'adresse e-mail du compte FullMargin\n" +
        "• le compte MT5 concerné\n" +
        "• le nom du token utilisé\n" +
        "• une description précise du problème\n" +
        "• une capture du journal\n" +
        "• une capture de l'Agent sur MT5\n" +
        "• la période ou les trades concernés",
    },
  ],
  related: ["agent-ia-mt5", "execution", "strategy-hub"],
};

export const en = {
  title: "Automatic journal",
  tagline: "Automatic tracking of your MT5 trades",
  readMin: 6,
  intro:
    "The Automatic journal is the FullMetrix tool that collects, organises and analyses the data coming from connected MetaTrader 5 accounts. It lets you follow your trading activity without recording each position manually.",
  brief: [
    "Find your positions, results and statistics with no manual entry",
    "Filter by account, period, asset, side or outcome",
    "Get an AI Analysis of your strengths, mistakes and habits",
  ],
  steps: [
    { title: "Install and connect the AI Agent", text: "AI Agent installed on MetaTrader 5, account connected with a valid token." },
    { title: "Allow the communication", text: "Algorithmic trading enabled and the FullMetrix WebRequest allowed in MT5." },
    {
      title: "Keep MetaTrader 5 open",
      text: "MT5 open and connected to the internet: data is then transferred automatically to FullMetrix.",
    },
    { title: "Filter, then analyse", text: "Select the account and period, apply the filters, then read the AI Analysis." },
  ],
  tips: [
    "One token per account: that is what keeps statistics cleanly separated.",
    "The journal never opens or modifies a position: those actions live in the Execution section.",
    "If a figure looks off, compare it with the history shown directly in MT5.",
  ],
  faq: [
    {
      q: "What is the Automatic journal?",
      a:
        "The Automatic journal is the FullMetrix tool that collects, organises and analyses the data coming from connected MetaTrader 5 accounts.\n\n" +
        "It lets you follow your trading activity without recording each position manually.",
    },
    {
      q: "What do I need to use it?",
      a:
        "For data to appear in the journal you must:\n" +
        "• install the AI Agent on MetaTrader 5\n" +
        "• connect the account with a valid token\n" +
        "• enable algorithmic trading\n" +
        "• allow the FullMetrix WebRequest\n" +
        "• keep MetaTrader 5 open and connected to the internet\n\n" +
        "Once the connection is established, data is transferred to FullMetrix automatically.",
    },
    {
      q: "What information does the journal show?",
      a:
        "The journal shows:\n" +
        "• open and closed positions\n" +
        "• profits and losses\n" +
        "• total number of trades\n" +
        "• win rate\n" +
        "• results per asset\n" +
        "• BUY and SELL performance\n" +
        "• volumes used\n" +
        "• Stop Loss and Take Profit levels\n" +
        "• drawdown\n" +
        "• the overall account evolution",
    },
    {
      q: "Are trades added automatically?",
      a:
        "Yes.\n\n" +
        "When the AI Agent is properly connected, the MT5 account trades are added to the journal automatically.\n\n" +
        "You normally never need to record them manually.",
    },
    {
      q: "Can I review several accounts?",
      a:
        "Yes.\n\n" +
        "You can connect several MT5 accounts to FullMetrix.\n\n" +
        "To keep each account's statistics clearly separated, use a different token per account.\n\n" +
        "If several accounts share the same token, their data can be grouped in the same journal.\n\n" +
        "That can help for an overall view, but it makes analysing one specific account harder.",
    },
    {
      q: "Can I filter the data?",
      a:
        "Yes.\n\n" +
        "Depending on the options available, you can filter results by:\n" +
        "• account\n" +
        "• period\n" +
        "• asset\n" +
        "• buy or sell\n" +
        "• winning or losing trade\n" +
        "• open or closed position\n\n" +
        "Filters let you analyse a specific part of your activity more precisely.",
    },
    {
      q: "What is the journal AI Analysis for?",
      a:
        "The journal includes an AI Analysis section able to study all the data of the connected account.\n\n" +
        "It can help you identify:\n" +
        "• your strengths\n" +
        "• your most frequent mistakes\n" +
        "• the habits that reduce your performance\n" +
        "• the assets you perform best and worst on\n" +
        "• differences between your BUY and SELL results\n" +
        "• the periods where your results are best or worst\n" +
        "• problems related to your risk management",
    },
    {
      q: "What can the AI Analysis recommend?",
      a:
        "From the available data, the AI Analysis can suggest what to:\n" +
        "• improve\n" +
        "• change\n" +
        "• reduce\n" +
        "• stop\n" +
        "• keep applying\n\n" +
        "Recommendations may concern:\n" +
        "• risk management\n" +
        "• position size\n" +
        "• trading frequency\n" +
        "• the assets traded\n" +
        "• trading hours or days\n" +
        "• winning habits to keep\n" +
        "• negative behaviours to correct",
    },
    {
      q: "Does the AI Analysis replace the trader's own analysis?",
      a:
        "No.\n\n" +
        "Recommendations are generated from the data available in the journal.\n\n" +
        "You must always:\n" +
        "• verify the information\n" +
        "• take the context of your trades into account\n" +
        "• compare the recommendations with your strategy\n" +
        "• decide yourself which changes to apply\n\n" +
        "The AI Analysis helps you understand your performance, but does not guarantee automatic improvement.",
    },
    {
      q: "Can the Automatic journal modify positions?",
      a:
        "No.\n\n" +
        "The Automatic journal mainly collects, organises and analyses account data.\n\n" +
        "It never opens a position by itself and never modifies trades.\n\n" +
        "Opening, modifying and closing live in the dedicated tools, mainly the Execution section.",
    },
    {
      q: "Why are some trades missing?",
      a:
        "The most frequent causes are:\n" +
        "• MetaTrader 5 is closed\n" +
        "• the AI Agent is no longer active\n" +
        "• algorithmic trading is disabled\n" +
        "• the WebRequest URL was removed\n" +
        "• the token is missing or incorrect\n" +
        "• the MT5 account is disconnected\n" +
        "• the sync is not finished\n" +
        "• the wrong account or period is selected",
    },
    {
      q: "What if the journal stops syncing?",
      a:
        "Check:\n" +
        "• that MetaTrader 5 is open\n" +
        "• that the trading account is connected\n" +
        "• that the AI Agent is still active\n" +
        "• that algorithmic trading is enabled\n" +
        "• that https://ia.fullmargin.net is still allowed in WebRequest\n" +
        "• that the token is correctly filled in\n" +
        "• that the right account is selected in FullMetrix\n\n" +
        "Then refresh the journal page.",
    },
    {
      q: "Can the results differ from MT5?",
      a:
        "Journal data comes from the connected MetaTrader 5 account.\n\n" +
        "A temporary difference can still appear in case of:\n" +
        "• sync delay\n" +
        "• wrong account selected\n" +
        "• several accounts grouped under the same token\n" +
        "• an active filter\n" +
        "• an incorrect period\n" +
        "• an Agent connection problem\n\n" +
        "When in doubt, compare with the history shown directly in MT5.",
    },
    {
      q: "How do I contact support?",
      a:
        "For a faster answer, we recommend contacting FullMargin support on WhatsApp.\n\n" +
        "Please send:\n" +
        "• the email address of your FullMargin account\n" +
        "• the MT5 account involved\n" +
        "• the name of the token used\n" +
        "• a precise description of the problem\n" +
        "• a screenshot of the journal\n" +
        "• a screenshot of the Agent on MT5\n" +
        "• the period or trades involved",
    },
  ],
  related: ["agent-ia-mt5", "execution", "strategy-hub"],
};
